import React from 'react';
import questions from '../data/database.json';

import Layout from '../components/Layout';
import Pagination from '../components/Pagination';

import { unified } from 'unified';
import markdown from 'remark-parse';
//import slug from 'remark-slug'
//import toc from 'remark-toc'
//import github from 'remark-github';
import remark2rehype from 'remark-rehype';
import highlight from 'rehype-highlight';
import rehype2react from 'rehype-react';

import 'highlight.js/styles/a11y-dark.css';
import Seo from '../components/Seo';

// !TODO Needs Fix Quesiton
// 8
// 25
// 33
// 152
// 237

const paginate = (start = 0, limit = 10) => {
  let source = '';
  let header = '';
  for (let i = start; i < start + limit; i++) {
    const question = questions[i];
    if (question) {
      source += question;
      header +=
        question.slice(question.indexOf('.') + 6, question.indexOf('?') + 1) +
        ' ';
    }
  }
  return { header, source };
};

var processor = unified()
  .use(markdown)
  //.use(slug)
  //.use(toc)
  //.use(github, { repository: 'rehypejs/rehype-react' })
  .use(remark2rehype)
  .use(highlight)
  .use(rehype2react, { createElement: React.createElement });

const QuestionArchive = (props) => {
  const { pageContext } = props;
  const {
    humanPageNumber, // starts from 1
    limit,
    nextPagePath,
    numberOfPages,
    // pageNumber, // starts from 0
    previousPagePath,
    skip,
  } = pageContext;
  const { header, source } = React.useMemo(
    () => paginate(skip, limit),
    [skip, limit]
  );

  return (
    <div className="container px-3 py-6">
      <Seo
        title="React interview question and answer | Interview React"
        description={header}
      />
      <Pagination
        previousPagePath={previousPagePath}
        nextPagePath={nextPagePath}
        humanPageNumber={humanPageNumber}
        numberOfPages={numberOfPages}
      />
      <div className="content">{processor.processSync(source).result}</div>
      <Pagination
        previousPagePath={previousPagePath}
        nextPagePath={nextPagePath}
        humanPageNumber={humanPageNumber}
        numberOfPages={numberOfPages}
      />
    </div>
  );
};

const QuestionArchiveWithLayout = (props) => (
  <Layout>
    <QuestionArchive {...props} />
  </Layout>
);

export default QuestionArchiveWithLayout;
